export const SET_SLIDE_LOADING = "SET_SLIDE_LOADING";

export const SET_SLIDE_NOT_LOADING = "SET_SLIDE_NOT_LOADING"